<template>
  <b-card>
    <template #header>
      <h5 class="mb-0">Filtros</h5>
    </template>
    <b-row>
      <b-form-group label="#COD" class="col-12 col-md-6 col-lg-4">
        <b-form-input v-model="form.id" placeholder="Código do pedido" trim />
      </b-form-group>

      <b-form-group label="Cliente" class="col-12 col-md-6 col-lg-4">
        <select-cliente v-model="form.cliente_id" />
      </b-form-group>

      <b-form-group label="CNPJ" class="col-12 col-md-6 col-lg-4">
        <cnpj v-model="form.cnpj" placeholder="00.000.000/00000-00" />
      </b-form-group>

      <b-form-group label="Plano" class="col-12 col-md-6 col-lg-4">
        <select-plano v-model="form.plano_id" />
      </b-form-group>

      <b-form-group label="Periodicidade" class="col-12 col-md-6 col-lg-4">
        <b-form-select v-model="form.periodicidade" :options="periodicidades" />
      </b-form-group>

      <b-form-group label="Status" class="col-12 col-md-6 col-lg-4">
        <b-form-select v-model="form.status" :options="statusOptions" />
      </b-form-group>

      <b-form-group label="Período de" class="col-12 col-md-6 col-lg-4">
        <date-input
          v-model="form.periodo_de"
          input-class="form-control"
          format="dd/MM/yyyy"
          placeholder="DD/MM/AAAA"
        />
      </b-form-group>

      <b-form-group label="Até" class="col-12 col-md-6 col-lg-4">
        <date-input
          v-model="form.periodo_ate"
          input-class="form-control"
          format="dd/MM/yyyy"
          placeholder="DD/MM/AAAA"
        />
      </b-form-group>
    </b-row>
    <template #footer>
      <b-row>
        <b-button
          class="ml-auto"
          variant="exitos"
          @click="$emit('search', validFields)"
        >
          Buscar
        </b-button>
      </b-row>
    </template>
  </b-card>
</template>

<script>
import cloneDeep from "lodash/cloneDeep";

import Cnpj from "@/components/Form/Cnpj.vue";
import DateInput from "@/components/Form/DateInput.vue";
import SelectCliente from "@/modules/clientes/Components/SelectCliente.vue";
import { getPeriodicidades } from "@/modules/planos/Components/Form/getPeriodicidades";
import SelectPlano from "@/modules/planos/Components/SelectPlano.vue";

const getEmptyForm = () => ({
  id: "",
  cliente_id: null,
  cnpj: "",
  periodicidade: null,
  status: null,
  periodo_de: null,
  periodo_ate: null,
  plano_id: null,
});

export default {
  components: {
    Cnpj,
    DateInput,
    SelectCliente,
    SelectPlano,
  },
  props: {},
  emits: ["search"],
  data: () => ({
    form: getEmptyForm(),
  }),
  computed: {
    periodicidades() {
      return getPeriodicidades();
    },
    statusOptions() {
      return [
        { value: null, text: "Selecione..." },
        { value: "AGUARDANDO_PAGAMENTO", text: "Aguardando pagamento" },
        { value: "PAGO", text: "Pago" },
        { value: "PROCESSADO", text: "Processado" },
        { value: "PENDENTE", text: "Pendente" },
        { value: "ERRO", text: "Erro" },
        { value: "INADIMPLENTE", text: "Inadimplente" },
        { value: "CANCELADO", text: "Cancelado" },
      ];
    },
    validFields() {
      const baseFilters = {
        ...getEmptyForm(),
        ...cloneDeep(this.form || {}),
      };

      return Object.keys(baseFilters).reduce((acc, key) => {
        if (!!baseFilters[key]) acc[key] = baseFilters[key];

        return acc;
      }, {});
    },
  },
};
</script>
<style scoped lang="scss">
::v-deep .datepicker {
  height: auto !important;
}

::v-deep .form-control-custom {
  &[role="combobox"] {
    height: auto !important;
    padding: 0;
  }
}
</style>
